import React from 'react'
import { Modal } from 'react-bootstrap'

export default function ErrorNetwork({ modals, setModals }) {
  return (
    <>
      <Modal
        show={modals.errNetwork}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        contentClassName='text-center borderadius'
      >
        <Modal.Header closeButton className='border-bottom-0 pb-0 button'></Modal.Header>
        <p className='text-center pt-3'>Algo ha salido mal</p>
        <p className='pl-5 pr-5 mb-0 description'>Revisa tu conexión de internet.</p>
        <div className='button__primary pt-lg-5 p-4'>
          <div className='px-lg-5 mx-lg-5'>
            <button onClick={() => setModals({ ...modals, errNetwork: false })} className='btn btn-block btn-primary'>
              Intenta nuevamente
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}
